// Platform-agnostic runtime configuration.
//
// `import.meta.env` (Vite) cannot be parsed by Metro (React Native), and
// `process.env.EXPO_PUBLIC_*` (Expo) does not exist on web. So shared code must
// NOT read either directly. Instead, each host app reads its own bundler's env
// at startup and injects the values here via `configureAppEnv()` before any
// shared service is used.
//
//   web    → web/src/config/firebaseInit.ts  (reads import.meta.env.VITE_*)
//   mobile → mobile/app/_layout or entry      (reads process.env.EXPO_PUBLIC_*)

export interface FirebaseEnv {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface AppEnv {
  firebase: FirebaseEnv;
  /** Optional server proxy that injects the Anthropic key (preferred in prod). */
  claudeProxyUrl?: string;
  /** Direct Anthropic key — dev/local only; never ship in a client bundle. */
  claudeApiKey?: string;
  /** Point Firebase at local emulators (dev only). */
  useEmulators?: boolean;
}

let current: AppEnv | null = null;

/** Inject the host app's resolved environment. Call once, at startup. */
export function configureAppEnv(env: AppEnv): void {
  current = env;
}

/** Read the injected environment. Throws if the host forgot to configure it. */
export function getAppEnv(): AppEnv {
  if (!current) {
    throw new Error(
      'App env not configured. Call configureAppEnv() at startup before using shared services.',
    );
  }
  return current;
}
